var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PageTitle', [_vm._v("您尚未註冊 POYA Buy 帳號")]), _c('p', {
    staticClass: "s-mb-10"
  }, [_vm._v("請前往 POYA Buy 完成註冊後，回到 LINE 完成會員綁定即可下單。")]), _c('a', {
    staticClass: "s-btn s-btn-primary",
    attrs: {
      "href": "https://www.poyabuy.com.tw/Login/HttpLoginRelayToHttps/?rt=https%3A%2F%2Fwww.poyabuy.com.tw%2F&reason=notlogin"
    }
  }, [_vm._v("前往註冊")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }